/**
 * Every fact the site states about the company, in one place.
 *
 * These values are what Apple and Dun & Bradstreet check the site against
 * during D-U-N-S and Apple Developer Program enrollment. The legal name, the
 * registration number and the address must match the certificate of
 * incorporation and the D-U-N-S record character for character. Change them
 * here and nowhere else; `company.test.ts` pins them.
 */
export const company = {
  legalName: 'Divergent Networks Limited',
  shortName: 'Divergent Networks',
  entityType: 'Private limited company',
  registrationNumber: 'PVT-KW13RKRW',
  incorporated: '17 September 2026',
  incorporationAct: 'Companies Act, 2015',
  jurisdiction: 'Republic of Kenya',
  asn: 'AS50391',

  address: {
    lines: ['Joelan Motors, Wendani Road', 'P.O. Box 2416-00621, Village Market'],
    country: 'Kenya',
  },

  email: 'info@divergentnetworks.org',
  phoneDisplay: '+254 722 860 894',
  phoneHref: 'tel:+254722860894',

  domain: 'divergentnetworks.org',
  url: 'https://www.divergentnetworks.org',
} as const;

export const presence = [
  {
    region: 'Africa',
    places: ['Kenya', 'South Africa'],
    note: 'Headquarters and engineering in Kenya, with an established market presence in South Africa.',
  },
  {
    region: 'Europe',
    places: ['Denmark'],
    note: 'A dedicated office serving as an operational node for European partners.',
  },
  {
    region: 'Indian Ocean',
    places: ['Mauritius'],
    note: 'A dedicated office supporting cross-border operations and regional partners.',
  },
  {
    region: 'Asia',
    places: ['China'],
    note: 'Market presence that anchors our hardware and supply-chain relationships.',
  },
] as const;
